import type { FaireProductEntity } from "../../entity_types/product";

export const p_dmk67e6hmc: FaireProductEntity = {
  token: "p_dmk67e6hmc",
  type: "product",
  name: "Killer Pickle",
  brandToken: "b_bqjnry3mfv",
  brandName: "Haffs Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/1802dba3e0435fa9f6cf8fadfe04a09990a783f03984d9114149b9cba5eff56b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16b1bb9c857f703da8c07f68e120111a70a915918764ee6c828a5988bd072ca8.jpeg",
  ],
  priceDollars: 5.9,
  description:
    "Killer pickle is the scorpion pepper charged version of our best seller Trippy Pickle.  Trippy slayed but people asked for even more bite.  So we bring you this monstrously hot dill pickle hot sauce. We have  two versions of this sauce.  Red and yellow.  ",
  tags: [],
  msrpDollars: 11.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:14.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
